import { Favorite } from "./type";
import { PRODUCT } from "../Product/Constain";

export const FAVORITE: Favorite = {
  product: PRODUCT,
  user: undefined,
};
